import React from 'react';
import classNames from 'classnames';
import View from '@loggi/ui/components/view';

function getLabelElement(content, styles) {
  const labelClasses = classNames(styles);

  return (
    <View inline className={labelClasses}>
      {content}
    </View>
  );
}

export { getLabelElement };
